import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const applicationService = {
    create: async (data) => {
        try {
            const res = await axiosService.post(endPoints.application.base, data);

            return res;
        } catch (error) {
            throw error;
        }
    },
    getAllByCurrentUser: async (page) => {
        try {
            const res = await axiosService.get(endPoints.application.byCurrentUser, {
                params: {
                    page
                }
            });

            return res;
        } catch (error) {
            throw error;
        }
    },
    getByRequest: async (id) => {
        try {
            const res = await axiosService.get(`${endPoints.application.base}${id}/applications-by-request/`);

            return res;
        } catch (error) {
            throw error;
        }
    },
    getFilteredByRequest: async (id, params) => {
        try {
            const res = await axiosService.get(`${endPoints.application.base}${id}/applications-by-request/`, {
                params
            });

            return res;
        } catch (error) {
            throw error;
        }
    }
}

export {
    applicationService,
}
